import { transformTokenHtmlToObject as run } from '@emartech/content-blocks-token';

export const transformTokenHtmlToObject = { run };
